import { render } from "./LightboxCampaignDetails.vue?vue&type=template&id=65cf2970"
import script from "./LightboxCampaignDetails.vue?vue&type=script&lang=js"
export * from "./LightboxCampaignDetails.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__